import { createFileRoute } from '@tanstack/react-router';
import { RouteStub } from '@/components/shared/RouteStub';

export const Route = createFileRoute('/work/$publicWorkId')({
  component: () => (
    <RouteStub
      title="Public work page"
      phase="Phase 2 — Public registry"
      detail="Renders only if the work has is_publicly_listed = true on the backend. Otherwise, returns a not-found view."
    />
  ),
});
